module.exports = __webpack_public_path__ + "img/chargingport_1000.acd87a17.png";